import {Component, React, observer} from '$src/handy'
import moment from 'moment'
import * as css from './NotificationsMenu.css'
import HornIcon from 'react-icons/lib/fa/bullhorn'

interface Props {
  isOpen: boolean
  data: ({
    _id: string
    type: string
    title: string
    content: string[]
    createdAt: string
    updatedAt: string
  } | undefined)[]
  onClose: Function
  buttonNode: any
}

@observer
export default class NotificationsMenu extends Component<Props, {}> {
  nodeRef: any

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  setNodeRef = (node) => {
    this.nodeRef = node;
  }

  handleClickOutside = () => {
    this.props.onClose()
  }

  handleClick = (e) => {
    if ((this.nodeRef && this.nodeRef.contains(e.target)) ||
      (this.props.buttonNode && this.props.buttonNode.contains(e.target))) {
      return
    }
    this.handleClickOutside()
  }

  render() {
    const {isOpen, data} = this.props

    return isOpen  ? (
      <div
        className={css.container}
        ref={this.setNodeRef}
      >
        <div className={css.header}>Newest notifications</div>
        <div className={css.body}>
          {data && data.length > 0 ? (
            data.map((n, i) => (
              <div className={css.notification} key={i}>
                <p className={css.date}>
                  {moment(n.updatedAt).format('D.M.YYYY HH.mm')}
                </p>
                <h4 className={css.title}>{n.title}</h4>
                <div className={css.content}>
                  {n.content.map(str => <p>{str}</p>)}
                </div>
              </div>
            ))
          ) : (
            <div className={css.empty}>
              <HornIcon style={{ fill: '#ccc', height: '4em', width: '4em' }} />
              <p>No new notifications</p>
            </div>
          )}
        </div>
      </div>
    ) : null
  }
}



// WEBPACK FOOTER //
// ./src/common/PageLayout/NotificationsMenu.tsx